import React from 'react';
import './About.css';

import { Button, Heading } from '../../../components';
import { about, images } from '../../../constants';

import { FaLeaf } from 'react-icons/fa';
import { useTranslation } from 'react-i18next';

const About = () => { 

  const { t } = useTranslation();

  return (

    <section className="about">

      {/* About Image */}
      <div className="image">
        <div className="sub-image">
        <img src={images.about1} alt='About-Pic-1' />
        </div>
        <div className="sub-image last">
        <img src={images.about2} alt='About-Pic-2' />
          <div className="experience">
            <span>{t(about.experience.years)}</span> {t('about.experience.text')}
          </div>
        </div>
      </div>

      {/* About Content */}
      <div className="content">

        <Heading title={t('about.heading')} subTitle={t('about.sub')} sideHeading={true} />

        {/* Description */}
        <p>{t('about.description')}</p>

        {/* Key Features */}
        <ul className="about-features">
          {about.points.map((point, index) => (
            <li key={index}>
              <FaLeaf className="icon" /> {/* Leaf icon */}
              <span>{t(`about.points.${index}`)}</span>
            </li>
          ))}
        </ul>

        <Button link={about.button.link} title={t('about.button.text')} /> {/* About-Us Button */}

      </div>

    </section>
  );
}

export default About;